const ON_CHANGE_DEBOUNCE_TIMER = 300;
/** Cart quantity changes: short debounce; drawer totals update optimistically before fetch. */
const CART_QUANTITY_DEBOUNCE_MS = 350;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
